export default __webpack_public_path__ + "static/media/cho_thue_xe_tu_lai_hanoi.735438af.svg";